import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1445dce6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "agreement-container xa-line__full-top" }
const _hoisted_2 = { class: "pb32" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"title mt16 ftw\" data-v-1445dce6>2022 年极加服务合同</div><div class=\"content\" data-v-1445dce6> 为了让广大用户（下称：“您”）能够享受到高效、及时、全面的售后服务需求，向您提供良好的产品使用与服务体验，广州极飞科技服务有限公司（下称：“极飞”）为您提供极飞农业无人机产品之“极加服务”。 </div><div class=\"content ftw txt-under\" data-v-1445dce6> 请您认真阅读本服务合同内所有条款，尤其是加粗或加下划线重点提示的部分。本服务合同一经您的确认，即视为您理解并同意本服务合同内所有条款，并同意将严格执行；如您不认可本服务合同内部分或全部的条款，请选择离开本界面。 </div><div class=\"content\" data-v-1445dce6>一、极加服务</div><div class=\"content\" data-v-1445dce6> “极加服务”是极飞推出的极飞科技农业无人机产品 <span class=\"ftw\" data-v-1445dce6> （仅限2021款P80、P40、V40以及2022款P100、V50农业无人机，以下称“产品”） </span> 增值保障服务，包括备用产品服务、不计免赔服务，解决您使用产品的后顾之忧。 </div><div class=\"content\" data-v-1445dce6>（一）备用产品服务</div><div class=\"content\" data-v-1445dce6> 1、当您的产品发生故障且无法在短时间内修复时，为了不影响您的作业需求，您可通过极飞授权的分销商/经销商、极飞直营服务站、极飞移动服务站、极飞服务车等途径优先选择备用产品服务，您的产品经极飞直营服务站、极飞移动服务站、极飞服务车修复后，您在接到前述服务主体的通知后及时归还备用产品的一项服务； </div><div class=\"content\" data-v-1445dce6> 2、<span class=\"ftw txt-under\" data-v-1445dce6>关于您如何领取及归还备用产品、以及涉及到可能需要您支付相应费用等规则以您领取备用产品时确认的《极飞科技备用产品使用协议》约定为准。</span></div><div class=\"content\" data-v-1445dce6>（二）不计免赔服务</div><div class=\"content\" data-v-1445dce6> 1、在“极加服务”有效期限内，产品在正常飞行作业中出现故障造成产品的结构件、易损件等损坏的，极飞提供不限次数、不限额度、不限责任的免费维修服务（即不收取配件费用和维修工时费）。 </div><div class=\"content ftw txt-under\" data-v-1445dce6> 2、可享受“不计免赔服务”的产品范围不包含农业无人机周边产品中的单手控、发电机、电池。单手控、发电机、电池，该类产品的服务规则按极飞科技官方发布的产品质量保障服务（即产品质保服务）执行。 </div><div class=\"content ftw txt-under\" data-v-1445dce6> 3、您理解并同意：在“极加服务”期间，极飞为您所提供（更换）的配件， 并不一定为全新配件，但其功能可满足您对产品正常的使用需求。 </div><div class=\"content\" data-v-1445dce6>二、不属于极加服务范围的情形：</div><div class=\"content\" data-v-1445dce6> 1、因未按照产品使用说明书要求正确使用、维护而造成产品损坏的，及私自改装、人为损坏、使用非极飞原厂配件等非产品质量问题造成的产品故障或损坏的。 </div><div class=\"content\" data-v-1445dce6> 2、因不可抗力因素，如水灾、火灾、雷击、交通事故等造成的产品故障或损坏的。 </div><div class=\"content\" data-v-1445dce6>3、产品发生故障后，您自行处置不当造成对故障原因无法做出技术鉴定的。</div><div class=\"content\" data-v-1445dce6> 4、由未获得极飞授权的个人或实体进行的任何极飞科技产品的操作、维修及其所导致的极飞产品损坏，包括但不限于因前述个人或实体使用非极飞科技原厂零部件进行维修而造成极飞科技产品损坏的。 </div><div class=\"content\" data-v-1445dce6>5、产品无有效三包凭证或擅自涂改三包凭证的。</div><div class=\"content\" data-v-1445dce6>6、三包凭证上记载的产品型号、出厂编码与产品实物不相符的。</div><div class=\"content\" data-v-1445dce6>7、产品铭牌、出厂编码被涂改或损坏，导致产品身份信息无法识别的。</div><div class=\"content\" data-v-1445dce6> 8、产品被用于特殊使用条件或目的的，如比赛竞技、表演娱乐、试验、军事行动、征用等用途。 </div><div class=\"content\" data-v-1445dce6> 9、与非极飞原厂或非极飞认可的第三方零配件、电池以及软件等同时使用时发生可靠性及兼容性问题所导致的损坏。 </div><div class=\"content\" data-v-1445dce6>10、超出“极加服务”有效期或服务范围。</div><div class=\"content\" data-v-1445dce6> 11、您仅限在极飞指定服务地点（极飞授权的分销商/经销商、极飞直营服务站、极飞移动服务站、极飞服务车等）享受极加服务，“极加服务”不提供除本服务合同约定之外的任何其他形式的实物、货币或价值形式的兑换及兑现。 </div><div class=\"content\" data-v-1445dce6>三、极加服务有效期</div><div class=\"content\" data-v-1445dce6>1、“极加服务”的有效期为1年。</div><div class=\"content\" data-v-1445dce6> 2、若您于2022年1月1日至2022年2月28日期间购买2021款P80、P40、V40及2022款P100、V50全新农业无人机享有赠送1年“极加服务”。则“极加服务”的起始日期为2022年3月1日【2022年1月1日至2022年2月28日期间您产品按照极飞科技产品质量保障服务（即产品质保服务）】。 </div><div class=\"content\" data-v-1445dce6> 3、若您于2022年3月1日-2022年12月31日期间的购买P80、P40、V40、P100、V50全新农业无人机享有赠送1年“极加服务”，则“极加服务”的起始日期为购机后的实际激活日期。 </div><div class=\"content\" data-v-1445dce6> 4、持有2021款P80、P40、V40农业无人机的您，若无人机在2022年2月28日截止前配套的2021年全保/延保服务期限未届满的，将在2022年3月1日起免费升级享受“极加服务”，有效期至原全保/延保服务期限届满。 </div><div class=\"content\" data-v-1445dce6> 5、持有2021款P80、P40、V40农业无人机的您，若无人机在2022年3月1日前配套的2021年全保/延保服务期限届满的，可以按照极加服务政策单独购买“极加服务”。 </div><div class=\"content\" data-v-1445dce6> 6、<span class=\"ftw\" data-v-1445dce6>极飞赠送的首年“极加服务”生效后，若在“极加服务”有效期内发生极飞农业无人机所有权转移，则“极加服务”自动失效。</span>您单独购买“极加服务”并在“极加服务”有效期内发生极飞农业无人机所有权转移的，“极加服务”随无人机一并转移直至原您单独购买的“极加服务”有效期限届满。 </div><div class=\"content\" data-v-1445dce6>五、双方的权利义务</div><div class=\"content\" data-v-1445dce6> 1、您获得极飞“极加服务”后，应严格按照本服务合同及相关服务协议（包括但不限于《极飞科技备用产品使用协议》等）约定予以执行。 </div><div class=\"content\" data-v-1445dce6> 2、极飞将对您提交的极飞“极加服务”保障单进行审查核实，并将严格按照“极加服务”范围为您提供相应的售后保障服务。 </div><div class=\"content\" data-v-1445dce6> 3、极飞有权根据国家法律法规、市场政策变动、产品服务内容或计划等原因对“极加服务”项目的具体规则进行调整，并提前至少30个自然日以有效方式通知您，通知方式包括但不限于通过极飞官网、极飞服务小程序、邮件、电话、信息等方式。 </div><div class=\"content\" data-v-1445dce6> 4、您不得利用极飞“极加服务”恶意套取极飞零部件，否则视为严重违约，一经发现，极飞有权立即解除本服务合同及终止极飞“极加服务”且无需退还任何费用，该您将被纳入极飞服务项目的黑名单，极飞有权不再为该您提供当年度的极飞“极加服务”。您如造成极飞损失的还应依法承担赔偿责任。 </div><div class=\"content\" data-v-1445dce6>六、争议解决</div><div class=\"content\" data-v-1445dce6> 1、本服务合同条款仅适用于中华人民共和国境内（港、澳、台除外）。本服务合同项下的任何争议之解决适用于中华人民共和国现行的法律、法规。 </div><div class=\"content\" data-v-1445dce6> 2、如双方就本服务合同的内容或执行发生任何争议的，双方应进行友好协商，协商未果的，任一方可向极飞注册登记地的人民法院提起诉讼。因此产生的律师费、诉讼费、公证费等合理费用由败诉一方承担。 </div><div class=\"content\" data-v-1445dce6>七、其他条款</div><div class=\"content\" data-v-1445dce6> 1、“极加服务”系极飞为您产品提供的定制型产品硬件增值服务，并不属于通常意义上的保险服务、或国家法律法规所强制要求的产品质量保修服务等范畴，极飞有权根据业务发展需求调整或取消该项产品服务。 </div><div class=\"content ftw txt-under\" data-v-1445dce6> 2、若本服务合同内容与《2022年极飞农业无人机“极加服务”政策》的内容有不一致的，以本服务合同约定为准；若本服务合同无约定，则极飞不再提供。 </div><div class=\"content ftw txt-under\" data-v-1445dce6> 3、本服务合同条款经您阅读并点击“同意”并进入下一步跳转界面后，或经您在服务合同条款上签字后视为您签署合同即刻生效，同时视为您已经详细阅读、理解并接受上述服务合同条款及其中所涉及的相关权利义务，并愿意承担由此产生的一切经济和法律责任。 </div><div class=\"content\" data-v-1445dce6> 4、上述形式签署的合同其法律效力与本服务合同条款的电子文档、扫描件、传真件、原件具有同等法律效力。 </div><div class=\"content\" data-v-1445dce6>5、在法律允许的范围内，极飞对本服务合同条款具有最终解释和修订权利。</div>", 45)
const _hoisted_48 = { class: "checkbox-wrap" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "我已阅读并同意《广州极飞科技服务有限公司2022年极加服务合同》", -1))
const _hoisted_50 = { class: "footer xag-page__footer nongfu-button-wrap" }

import { Button, Checkbox } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { computed, ref, Ref, onMounted, watch } from 'vue'
import { CacheSelectedContractAgree } from '@/config/jijia'
import AppHeader from '@/components/Header.vue'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'jijia-contract',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const isAgree: Ref<boolean> = ref(false)
const $router = useRouter()
const $route = useRoute()
const buttonText = computed(() => {
  const value = isAgree.value
  return value ? '我已阅读并同意合同协议内容' : '请完整阅读并勾选确认同意合同协议内容'
})
watch(isAgree, () => {
  console.log('isAfree.value', isAgree.value)
  if (isAgree.value) {
    sessionStorage.setItem(CacheSelectedContractAgree, '1')
  } else {
    sessionStorage.removeItem(CacheSelectedContractAgree)
  }
})
function toPayOrder() {
  $router.push({
    name: 'jijia-pay-order',
  })
}
function toPolicy() {
  $router.push({
    name: 'jijia-policy',
  })
}
onMounted(() => {
  const cacheStr = sessionStorage.getItem(CacheSelectedContractAgree)
  if (cacheStr) {
    isAgree.value = true
  } else {
    isAgree.value = false
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "合同和协议条款" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", { class: "enclosure" }, [
          _createElementVNode("div", { class: "content" }, [
            _createTextVNode(" 附件: "),
            _createElementVNode("span", {
              class: "xa-txt-blue",
              onClick: toPolicy
            }, "《2022年极飞农业无人机“极加服务”政策》")
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createVNode(_unref(Checkbox), {
            modelValue: isAgree.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAgree).value = $event)),
            class: "xa-vant-checkbox",
            shape: "square",
            "icon-size": "14px"
          }, {
            default: _withCtx(() => [
              _hoisted_49
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_50, [
      _createVNode(_unref(Button), {
        block: "",
        type: "success",
        class: "xa-vant-button",
        disabled: !isAgree.value,
        onClick: toPayOrder
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 64))
}
}

})